<template>
  <li class="nav-item">
    <a class="nav-link" :class="selectedClass">
      <i class="bi" :class="iconClass"></i>
      {{ text }}
    </a>
  </li>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import GuiidePlusView from "@/guiide/ts/guiideplus/guiidePlusView";

export default defineComponent({
  name: "SideBarNavItem",
  props: {
    text: { type: String, required: true },
    iconClass: { type: String, required: true },
    itemView: { default: GuiidePlusView.Dashboard, required: false },
    selectedView: { default: GuiidePlusView.Dashboard, required: true },
    transitoryOnly: { default: false }
  },
  computed: {
    selectedClass: function(): string {
      if (this.transitoryOnly) {
        return "";
      }
      return this.itemView == this.selectedView ? "nav-link-selected" : "";
    }
  }
});
</script>

<style scoped>
.nav-link {
  color: #333;
  font-size: 16px;
}

.nav-link-selected {
  color: #666666;
  font-weight: bold;
}

.nav-link i {
  margin-right: 10px;
}

.nav-link:hover {
  color: #999;
  border-bottom-color: transparent;
  cursor: pointer;
}

.nav-link .active {
  border-bottom-color: transparent;
  font-weight: 700;
  color: #000;
}
</style>
